<p-card>
  <ng-template pTemplate="header">
    <div class="flex justify-between">
      <div class="p-card-title">{{incident().summary}}</div>
      <div class="flex gap-1">
        <app-transition-button class="d-inline-block me-1" [incident]="incident()" (transitionComplete)="onTransitionComplete($event)"></app-transition-button>
        <span class="p-buttonset" role="group">
          <button pButton class="p-button-outlined" (click)="onAssign()">Assign</button>
          <button pButton class="p-button-outlined" (click)="onLinkTrip()">Link Trip</button>
          <button pButton class="p-button-outlined" routerLink="/incidents/{{incident().workItemId}}/edit">Edit</button>
        </span>
        <p-menu #moreMenu [model]="moreMenuItems" [popup]="true" appendTo="body"></p-menu>
        <p-button variant="outlined"  icon="pi pi-angle-down" iconPos="right"  label="More" (click)="moreMenu.toggle($event)"></p-button>
      </div>
    </div>
  </ng-template>

  <div class="incident-view">
    <div class="grid grid-cols-2 gap-4">
      <!-- Left Column - Incident Details -->
      <div class="col-span-2 md:col-span-1">
        <div class="grid grid-cols-12 gap-4">
          <label for="summary" class="lg:col-span-2 md:col-span-3">Summary</label>
          <div id="summary" class="lg:col-span-10 md:col-span-9">{{incident().summary}}</div>

          <label for="startDate" class="lg:col-span-2 md:col-span-3">Incident Date</label>
          <div id="startDate" class="lg:col-span-10 md:col-span-9">{{incident().startDate | date}}</div>

          <label for="priority" class="lg:col-span-2 md:col-span-3">Priority</label>
          <app-priority-button class="lg:col-span-10 md:col-span-9" [incident]="incident()"></app-priority-button>

          <label for="location" class="lg:col-span-2 md:col-span-3">Location</label>
          <div id="location" class="lg:col-span-10 md:col-span-9">{{location$ | async}}</div>

          <label for="Assignee" class="lg:col-span-2 md:col-span-3">Assigned To</label>
          <div id="Assignee" class="lg:col-span-10 md:col-span-9">{{assignee$ | async }}</div>

          <label class="lg:col-span-2 md:col-span-3">Linked Trips</label>
          <div class="lg:col-span-10 md:col-span-9">
            <ul>
              @for (trip of trips(); track trip) {
                <li>
                  {{trip.id}} - {{trip.tripDate | date}} - {{trip.groupName}} - {{trip.location}}
                </li>
              }
            </ul>
          </div>

          <label class="lg:col-span-2 md:col-span-3">Incident Reports</label>
          <div class="lg:col-span-10 md:col-span-9">
            @for (report of reports(); track report) {
              <div>
                <a routerLink="/incident-reports/{{report.incident.workItemId}}">{{report.incident.summary}} on {{report.incident.dateCreated | date:"medium"}}</a>
              </div>
            }
          </div>

          <label class="lg:col-span-2 md:col-span-3">Tags</label>
          <app-tag-display [incident]="incident()" [editMode]="true" class="lg:col-span-10 md:col-span-9 tag-large" (tagChanged)="tagsChanged()"></app-tag-display>

          <label for="description" class="lg:col-span-2 md:col-span-3">Description</label>
          <div id="description" class="lg:col-span-9 md:col-span-8 multi-line-display">{{incident().description}}</div>
        </div>
      </div>

      <!-- Right Column - Severity Impact Assessment -->
      @if (isIncidentClosed()) {
        <div class="col-span-2 md:col-span-1">
          <app-severity-impact-display [workItemId]="incident().workItemId"></app-severity-impact-display>
        </div>
      }
    </div>

    <p-divider class="col-span-12"></p-divider>

    <div class="col-span-12 mb-8">
      <app-work-item-attachments  [workItemId]="incident().workItemId"></app-work-item-attachments>
    </div>

    <div class="col-span-12 md:col-span-6">
      <h6>Comments</h6>
      <app-work-item-comment-view [workItemId]="incident().workItemId"></app-work-item-comment-view>
    </div>
  </div>


</p-card>
